module.exports = __webpack_public_path__ + "static/img/anli10.9f5149e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli/anli10.jpg
// module id = MKeW
// module chunks = 1